module.exports = __webpack_public_path__ + "img/338976169966519_image.jpg";